import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { CompanyMapper } from "features/planner/planner.mappers";

const initialState = Map({});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_COMPANIES: {
      if (error) return state;

      return Map(
        payload.map(Company => [
          Company.companyId.toString(),
          CompanyMapper.from(Company),
        ]),
      );
    }

    case ACTIONS.CREATE_COMPANY:
    case ACTIONS.GET_COMPANY:
    case ACTIONS.UPDATE_COMPANY: {
      if (error) return state;

      return state.set(
        payload.companyId.toString(),
        CompanyMapper.from(payload),
      );
    }

    case ACTIONS.DELETE_COMPANY: {
      if (error) return state;

      return state.delete(action.companyId.toString());
    }
    default:
      return state;
  }
};
